import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/compatible/es/form/index.js
// module id = 4576
// module chunks = 1